import { createActions, createReducer } from 'reduxsauce'

const listaPagos = [
    { value: '', label: 'Todas' },
    { value: 'S', label: 'Sim' },
    { value: 'N', label: 'Não' },
]

/**
 * Action types & creators
 */

export const { Types, Creators } = createActions({
    removeAdministracaoConsultaEmpenhoCredor: ['administracao'],
    removeExercicioEmpenhoInicialConsultaEmpenhoCredor: ['exercicioEmpenhoInicial'],
    removeExercicioEmpenhoFinalConsultaEmpenhoCredor: ['exercicioEmpenhoFinal'],
    removeNumeroEmpenhoInicialConsultaEmpenhoCredor: ['numeroEmpenhoInicial'],
    removeNumeroEmpenhoFinalConsultaEmpenhoCredor: ['numeroEmpenhoFinal'],
    removeDataEmpenhoInicialConsultaEmpenhoCredor: ['dataEmpenhoInicial'],
    removeDataEmpenhoFinalConsultaEmpenhoCredor: ['dataEmpenhoFinal'],
    removeDataVencimentoInicialConsultaEmpenhoCredor: ['dataVencimentoInicial'],
    removeDataVencimentoFinalConsultaEmpenhoCredor: ['dataVencimentoFinal'],
    removePagosConsultaEmpenhoCredor: ['pagos'],
    removeRecursoConsultaEmpenhoCredor: ['recurso'],
    removeDestinacaoConsultaEmpenhoCredor: ['destinacao'],
    removeNomeCredorConsultaEmpenhoCredor: ['nomeCredor'],
    removeCnpjConsultaEmpenhoCredor: ['cnpj'],
    removeCpfConsultaEmpenhoCredor: ['cpf'],
    removeDocumentoConsultaEmpenhoCredor: ['documento'],
    removeExercicioProtocoloInicialConsultaEmpenhoCredor: ['exercicioProtocoloInicial'],
    removeExercicioProtocoloFinalConsultaEmpenhoCredor: ['exercicioProtocoloFinal'],
    removeNumeroProtocoloInicialConsultaEmpenhoCredor: ['numeroProtocoloInicial'],
    removeNumeroProtocoloFinalConsultaEmpenhoCredor: ['numeroProtocoloFinal'],
    removeProcessoReferenciaConsultaEmpenhoCredor: ['processoReferencia'],
    removeCategoriaProcessoConsultaEmpenhoCredor: ['categoriaProcesso'],
    setMostraAplicarFiltroConsultaEmpenhoCredor: [],
    limpaFiltroConsultaEmpenhoCredor: [],
    aplicarFiltroConsultaEmpenhoCredor: ['filtro'],
})

const INITIAL_STATE = {
    administracao: [],
    exercicioEmpenhoInicial: '',
    exercicioEmpenhoFinal: '',
    numeroEmpenhoInicial: '',
    numeroEmpenhoFinal: '',
    dataEmpenhoInicial: '',
    dataEmpenhoFinal: '',
    dataVencimentoInicial: '',
    dataVencimentoFinal: '',
    pagos: { value: listaPagos[0].value, label: listaPagos[0].label },
    recurso: [],
    destinacao: [],
    nomeCredor: '',
    cnpj: '',
    cpf: '',
    documento: '',
    exercicioProtocoloInicial: '',
    exercicioProtocoloFinal: '',
    numeroProtocoloInicial: '',
    numeroProtocoloFinal: '',
    processoReferencia: '',
    categoriaProcesso: '',
    mostraAplicarFiltro: false,
}
const removeAdministracao = (state = INITIAL_STATE, action) => {
    state.administracao.splice(state.administracao.indexOf(action.administracao), 1)
    state.administracao = Array.from(state.administracao)
    return { ...state, mostraAplicarFiltro: true }
}
const removeExercicioEmpenhoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioEmpenhoInicial: '', mostraAplicarFiltro: true }
}
const removeExercicioEmpenhoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioEmpenhoFinal: '', mostraAplicarFiltro: true }
}
const removeNumeroEmpenhoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, numeroEmpenhoInicial: '', mostraAplicarFiltro: true }
}
const removeNumeroEmpenhoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, numeroEmpenhoFinal: '', mostraAplicarFiltro: true }
}
const removeDataEmpenhoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataEmpenhoInicial: '', mostraAplicarFiltro: true }
}
const removeDataEmpenhoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataEmpenhoFinal: '', mostraAplicarFiltro: true }
}
const removeDataVencimentoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataVencimentoInicial: '', mostraAplicarFiltro: true }
}
const removeDataVencimentoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataVencimentoFinal: '', mostraAplicarFiltro: true }
}
const removePagos = (state = INITIAL_STATE, action) => {
    return { ...state, pagos: '', mostraAplicarFiltro: true }
}
const removeRecurso = (state = INITIAL_STATE, action) => {
    state.recurso.splice(state.recurso.indexOf(action.recurso), 1)
    state.recurso = Array.from(state.recurso)
    return { ...state, mostraAplicarFiltro: true }
}
const removeDestinacao = (state = INITIAL_STATE, action) => {
    state.destinacao.splice(state.destinacao.indexOf(action.destinacao), 1)
    state.destinacao = Array.from(state.destinacao)
    return { ...state, mostraAplicarFiltro: true }
}
const removeNomeCredor = (state = INITIAL_STATE, action) => {
    return { ...state, nomeCredor: '', mostraAplicarFiltro: true }
}
const removeCnpj = (state = INITIAL_STATE, action) => {
    return { ...state, cnpj: '', mostraAplicarFiltro: true }
}
const removeCpf = (state = INITIAL_STATE, action) => {
    return { ...state, cpf: '', mostraAplicarFiltro: true }
}
const removeDocumento = (state = INITIAL_STATE, action) => {
    return { ...state, documento: '', mostraAplicarFiltro: true }
}

const removeExercicioProtocoloInicial = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioProtocoloInicial: '', mostraAplicarFiltro: true }
}
const removeExercicioProtocoloFinal = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioProtocoloFinal: '', mostraAplicarFiltro: true }
}
const removeNumeroProtocoloInicial = (state = INITIAL_STATE, action) => {
    return { ...state, numeroProtocoloInicial: '', mostraAplicarFiltro: true }
}
const removeNumeroProtocoloFinal = (state = INITIAL_STATE, action) => {
    return { ...state, numeroProtocoloFinal: '', mostraAplicarFiltro: true }
}
const removeProcessoReferencia = (state = INITIAL_STATE, action) => {
    return { ...state, processoReferencia: '', mostraAplicarFiltro: true }
}

const removeCategoriaProcesso = (state = INITIAL_STATE, action) => {
    return { ...state, categoriaProcesso: '', mostraAplicarFiltro: true }
}

const setMostraAplicarFiltro = (state = INITIAL_STATE, action) => {
    return { ...state, mostraAplicarFiltro: !state.mostraAplicarFiltro }
}

const aplicarFiltro = (state = INITIAL_STATE, action) => {
    action.filtro.mostraAplicarFiltro = false
    return action.filtro
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.REMOVE_ADMINISTRACAO_CONSULTA_EMPENHO_CREDOR]: removeAdministracao,
    [Types.REMOVE_EXERCICIO_EMPENHO_INICIAL_CONSULTA_EMPENHO_CREDOR]: removeExercicioEmpenhoInicial,
    [Types.REMOVE_EXERCICIO_EMPENHO_FINAL_CONSULTA_EMPENHO_CREDOR]: removeExercicioEmpenhoFinal,
    [Types.REMOVE_NUMERO_EMPENHO_INICIAL_CONSULTA_EMPENHO_CREDOR]: removeNumeroEmpenhoInicial,
    [Types.REMOVE_NUMERO_EMPENHO_FINAL_CONSULTA_EMPENHO_CREDOR]: removeNumeroEmpenhoFinal,
    [Types.REMOVE_DATA_EMPENHO_INICIAL_CONSULTA_EMPENHO_CREDOR]: removeDataEmpenhoInicial,
    [Types.REMOVE_DATA_EMPENHO_FINAL_CONSULTA_EMPENHO_CREDOR]: removeDataEmpenhoFinal,
    [Types.REMOVE_DATA_VENCIMENTO_INICIAL_CONSULTA_EMPENHO_CREDOR]: removeDataVencimentoInicial,
    [Types.REMOVE_DATA_VENCIMENTO_FINAL_CONSULTA_EMPENHO_CREDOR]: removeDataVencimentoFinal,
    [Types.REMOVE_PAGOS_CONSULTA_EMPENHO_CREDOR]: removePagos,
    [Types.REMOVE_RECURSO_CONSULTA_EMPENHO_CREDOR]: removeRecurso,
    [Types.REMOVE_DESTINACAO_CONSULTA_EMPENHO_CREDOR]: removeDestinacao,
    [Types.REMOVE_NOME_CREDOR_CONSULTA_EMPENHO_CREDOR]: removeNomeCredor,
    [Types.REMOVE_CNPJ_CONSULTA_EMPENHO_CREDOR]: removeCnpj,
    [Types.REMOVE_CPF_CONSULTA_EMPENHO_CREDOR]: removeCpf,
    [Types.REMOVE_DOCUMENTO_CONSULTA_EMPENHO_CREDOR]: removeDocumento,
    [Types.REMOVE_EXERCICIO_PROTOCOLO_INICIAL_CONSULTA_EMPENHO_CREDOR]: removeExercicioProtocoloInicial,
    [Types.REMOVE_EXERCICIO_PROTOCOLO_FINAL_CONSULTA_EMPENHO_CREDOR]: removeExercicioProtocoloFinal,
    [Types.REMOVE_NUMERO_PROTOCOLO_INICIAL_CONSULTA_EMPENHO_CREDOR]: removeNumeroProtocoloInicial,
    [Types.REMOVE_NUMERO_PROTOCOLO_FINAL_CONSULTA_EMPENHO_CREDOR]: removeNumeroProtocoloFinal,
    [Types.REMOVE_PROCESSO_REFERENCIA_CONSULTA_EMPENHO_CREDOR]: removeProcessoReferencia,
    [Types.REMOVE_CATEGORIA_PROCESSO_CONSULTA_EMPENHO_CREDOR]: removeCategoriaProcesso,
    [Types.SET_MOSTRA_APLICAR_FILTRO_CONSULTA_EMPENHO_CREDOR]: setMostraAplicarFiltro,
    [Types.LIMPA_FILTRO_CONSULTA_EMPENHO_CREDOR]: limpaFiltro,
    [Types.APLICAR_FILTRO_CONSULTA_EMPENHO_CREDOR]: aplicarFiltro,
})
